import { createStore } from "vuex";
import account from './modules/account';
import appHeader from './modules/app-header';
import modules from './modules/modules';
import notification from './modules/notification';
import organization from './modules/organization';

export default createStore({
  modules: {
    account,
    appHeader,
    modules,
    notification,
    organization,
  },
});
